import { useContext } from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Grid, Icon, LinearProgress } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CustomPagination } from 'utils/functions';
import {
  dropModalidadeTreino,
  dropTipoTreino,
  dropTipoProfissional,
  dropNacionalidadeProfissional,
} from 'utils/drops';
import { useDialog } from 'components/Modals';
import { GridContext } from 'contexts/GridContext';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Input from 'components/Input';
import Title from '../Components/Title';
import localeText from 'utils/localeText';
import moment from 'moment';

const Treinamento = ({ drops, loading, pessoal = {}, onSubmit, onDelete }) => {
  const { openDialog } = useDialog();
  const treinamentos = pessoal?.Treinamentos ?? [];

  const Modal = ({ item }) => {
    const defaultValues = {
      rotina: 'PessoalTreinamento',
      id: item?.id,
      pessoal_id: pessoal?.id,
      treinamento_id: item?.treinamento_id || null,
      dttreicap: item?.dttreicap || null,
      durtreicap: item?.durtreicap || '',
      modtreicap: item?.modtreicap || null,
      tptreicap: item?.tptreicap || null,
      nmprof: item?.nmprof || '',
      cpfprof: item?.cpfprof || '',
      tpprof: item?.tpprof || null,
      formprof: item?.formprof || '',
      codcbo: item?.codcbo || '',
      nacprof: item?.nacprof || null,
    };
    const { postLoading } = useContext(GridContext);
    const { control, handleSubmit } = useForm({ defaultValues });

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title title="Dados do Treinamento" disableMargin />
        </Grid>
        <Grid item xs={12}>
          <Dropdown
            control={control}
            label="Treinamento"
            name="treinamento_id"
            options={drops?.Treinamento}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            type="date"
            label="Data"
            name="dttreicap"
            control={control}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask label="Duração" name="durtreicap" control={control} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            name="modtreicap"
            control={control}
            label="Modalidade"
            options={dropModalidadeTreino}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            label="Tipo"
            name="tptreicap"
            control={control}
            options={dropTipoTreino}
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Instrutor / Profissional Responsável" />
        </Grid>
        <Grid item xs={12} sm={8}>
          <Input name="nmprof" label="Nome" control={control} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            label="CPF"
            name="cpfprof"
            control={control}
            mask="999.999.999-99"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            name="tpprof"
            control={control}
            label="Tipo de Profissional"
            options={dropTipoProfissional}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Input name="formprof" label="Formação" control={control} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Input name="codcbo" label="CBO" control={control} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            name="nacprof"
            control={control}
            label="Nacionalidade"
            options={dropNacionalidadeProfissional}
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            loading={postLoading}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title
          title="Treinamentos"
          disableMargin
          rightButton={
            <Button
              color="primary"
              variant="outlined"
              onClick={() => openDialog(<Modal />, 'Adicionar Treinamento')}
            >
              Adicionar
            </Button>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={treinamentos}
          columns={[
            {
              field: 'treinamento',
              headerName: 'Treinamento',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'dttreicap',
              headerName: 'Data',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'durtreicap',
              headerName: 'Duração',
              width: 150,
              sortable: false,
            },
            {
              field: 'modtreicap',
              headerName: 'Modalidade',
              width: 200,
              sortable: false,
            },
            {
              field: 'nmprof',
              headerName: 'Instrutor',
              width: 300,
              sortable: false,
            },
            {
              field: 'actions',
              headerName: 'Ações',
              type: 'actions',
              width: 100,
              getActions: ({ row }) => [
                <GridActionsCellItem
                  icon={<Icon>edit</Icon>}
                  label="Editar"
                  onClick={() =>
                    openDialog(<Modal item={row} />, 'Editar Treinamento')
                  }
                />,
                <GridActionsCellItem
                  icon={<Icon>delete</Icon>}
                  label="Excluir"
                  onClick={() =>
                    onDelete({ rotina: 'PessoalTreinamento', id: row?.id })
                  }
                />,
              ],
            },
          ]}
          autoHeight
          pagination
          pageSize={10}
          density="compact"
          loading={loading}
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          disableSelectionOnClick
          localeText={localeText}
          getRowHeight={() => 'auto'}
          components={{
            Pagination: CustomPagination,
            LoadingOverlay: LinearProgress,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default Treinamento;
